import classNames from 'classnames/bind';
import React from 'react';
import { NoDataDash } from '../../../../../components/formatters';
import { formatCommonDate } from '../../../../../utils/dateUtils';
import { GroupedTableRowRendererProps } from '../../GroupedTableRow/GroupedTableRow.types';
import styles from './DocumentDateRenderer.module.scss';

const cx = classNames.bind(styles);

const DocumentDateRenderer = <TData,>({
  data,
  columnConfig,
  tableConfig,
  row: { isDisabled, isHovered },
}: GroupedTableRowRendererProps<TData>): React.ReactElement => {
  const key = tableConfig.getRowKey(data);
  return (
    <div key={key} className={cx('body', { 'gray-out': isDisabled && isHovered })}>
      {data[columnConfig.dataKey] ? <span>{formatCommonDate(data[columnConfig.dataKey])}</span> : <NoDataDash />}
    </div>
  );
};

export default DocumentDateRenderer;
